'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import RadialProgressBar from '../RadialProgressBar';
import ResultHeader from './ResultHeader';
import ResultInfo from './ResultInfo';
import ResultSection from './ResultSection';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default class RadialResultSection extends Component {
  render() {
    const {
      displayValueUnit,
      displayValue,
      radialContainerClass,
      score,
      progressBarIcon,
      gradeType
    } = this.props;
    return /*#__PURE__*/_jsxs(ResultSection, {
      gradeType: gradeType,
      children: [/*#__PURE__*/_jsx(ResultHeader, Object.assign({}, this.props)), /*#__PURE__*/_jsxs("div", {
        className: radialContainerClass,
        children: [/*#__PURE__*/_jsx(RadialProgressBar, {
          score: score,
          children: /*#__PURE__*/_jsx("div", {
            className: `icon ${progressBarIcon}`
          })
        }), /*#__PURE__*/_jsxs("div", {
          className: "result-value",
          children: [displayValue, /*#__PURE__*/_jsx("span", {
            className: "result-value-unit",
            children: displayValueUnit
          })]
        })]
      }), /*#__PURE__*/_jsx(ResultInfo, Object.assign({}, this.props))]
    });
  }
}
RadialResultSection.propTypes = {
  gradeType: PropTypes.string,
  resultGrade: PropTypes.number,
  resultValueUnit: PropTypes.string,
  score: PropTypes.number,
  displayValueUnit: PropTypes.string,
  displayValue: PropTypes.number,
  radialContainerClass: PropTypes.object,
  progressBarIcon: PropTypes.string
};